// Package imports
import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';

// CSS imports
import './StaticDropdown.css';

// Icons
import { IoChevronDown } from 'react-icons/io5';

// Types
import { DropdownElement } from '../../types/dropdown/DropdownElement';

type Props = {
  label?: string;
  customLabel?: React.ReactNode;
  elements: DropdownElement[];
  className?: string;
  toggleMenu?: () => void;
};

const StaticDropdown: React.FC<Props> = ({
  label,
  customLabel,
  elements,
  className,
  toggleMenu,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      className={`StaticDropdown ${className ? className : ''}`}
      ref={wrapperRef}
    >
      <div onClick={toggleOpen} className='label-container'>
        {customLabel ? (
          <div className='label'>{customLabel}</div>
        ) : (
          <span className='label'>{label ? label : 'Your label'}</span>
        )}
        <IoChevronDown className={`chevron ${isOpen ? 'chevron-up' : null}`} />
      </div>
      {isOpen ? (
        <ul className='menu'>
          {elements.map((element: DropdownElement, index: number) => (
            <li key={index}>
              {element.isButton ? (
                <div
                  className='link-element'
                  onClick={() => {
                    toggleOpen();
                    if (toggleMenu) {
                      toggleMenu();
                    }
                    if (element.action !== undefined) {
                      element.action();
                    }
                  }}
                >
                  {element.ReactIcon ? (
                    <element.ReactIcon
                      className='nav-icon'
                      color={element.iconColor ? element.iconColor : '#6b3feb'}
                    />
                  ) : element.imgIcon ? (
                    <img
                      className='nav-icon'
                      src={element.imgIcon}
                      alt={element.label}
                    />
                  ) : null}
                  <span>{element.label}</span>
                </div>
              ) : (
                <Link
                  to={element.to ? element.to : '/'}
                  className='link-element'
                  onClick={() => {
                    toggleOpen();
                    if (toggleMenu) {
                      toggleMenu();
                    }
                  }}
                >
                  {element.ReactIcon ? (
                    <element.ReactIcon
                      className='nav-icon'
                      color={element.iconColor ? element.iconColor : '#6b3feb'}
                    />
                  ) : element.imgIcon ? (
                    <img
                      className='nav-icon'
                      src={element.imgIcon}
                      alt={element.label}
                    />
                  ) : null}
                  <span>{element.label}</span>
                </Link>
              )}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
};

export default StaticDropdown;
